import { render } from "./RevenueUpdateView.vue?vue&type=template&id=dddd1490"
import script from "./RevenueUpdateView.vue?vue&type=script&lang=js"
export * from "./RevenueUpdateView.vue?vue&type=script&lang=js"

import "./RevenueUpdateView.vue?vue&type=style&index=0&id=dddd1490&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__